export default __webpack_public_path__ + "static/media/nubravalley.4fa648ba.jpg";